import React from 'react';
import {
  BsInfoCircleFill,
  BsExclamationTriangleFill,
  BsXCircleFill,
  BsCheckCircleFill,
} from 'react-icons/bs';

export const BANNER_TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
} as const;

export type BannerType = (typeof BANNER_TYPES)[keyof typeof BANNER_TYPES];

export const BANNER_FLAG_KEYS = {
  APP: 'qcentralAppBanner',
  FEES: 'qcentralFeesBanner',
  FEES_PAGE: 'qcentralFeesPageBanner',
  TAX: 'qcentralTaxBanner',
  ACCOUNT_OPENING: 'qcentralAccountOpeningBanner',
  COMPLIANCE: 'qcentralComplianceBanner',
  POWERBI: 'qcentralPowerbiBanner',
} as const;

export type BannerFlagKey = (typeof BANNER_FLAG_KEYS)[keyof typeof BANNER_FLAG_KEYS];

export interface BannerFlagValue {
  title?: string;
  message?: string;
  type?: BannerType;
}

export type BannerFlags = Partial<Record<BannerFlagKey, BannerFlagValue>>;

export interface BannerThemeColors {
  bg: string;
  icon: string;
}

export const BANNER_THEME_COLORS: Record<BannerType, BannerThemeColors> = {
  [BANNER_TYPES.INFO]: {
    bg: 'colors.blueTransparent',
    icon: 'colors.blue',
  },
  [BANNER_TYPES.WARNING]: {
    bg: 'colors.yellowTransparent',
    icon: 'colors.yellow',
  },
  [BANNER_TYPES.ERROR]: {
    bg: 'colors.redTransparent',
    icon: 'colors.red',
  },
  [BANNER_TYPES.SUCCESS]: {
    bg: 'colors.greenTransparent',
    icon: 'colors.green',
  },
};

export const BANNER_ICONS: Record<BannerType, React.ComponentType> = {
  [BANNER_TYPES.INFO]: BsInfoCircleFill,
  [BANNER_TYPES.WARNING]: BsExclamationTriangleFill,
  [BANNER_TYPES.ERROR]: BsXCircleFill,
  [BANNER_TYPES.SUCCESS]: BsCheckCircleFill,
};
